module.exports = __webpack_public_path__ + "media/flags/bw-42436499.svg";